import { render, staticRenderFns } from "./SetServiceCost.vue?vue&type=template&id=58a7ffee"
import script from "./SetServiceCost.vue?vue&type=script&lang=js"
export * from "./SetServiceCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports